import { UploadThumbnailField } from './UploadThumbnailField'
import { withUploadThumbnailField } from './withUploadThumbnailField'

const ConnectedUploadStickerField =
  withUploadThumbnailField(UploadThumbnailField)

export { ConnectedUploadStickerField as UploadThumbnailField }
